import FreemiumLockModal from '.';
import { useFreemiumUpsellStore } from '../../../stores/freemiumUpsellStore';

/**
 * Instância única do modal de upsell, montada no topo da aplicação. É aberta
 * pela store `useFreemiumUpsellStore` — inclusive pelo interceptor do axios
 * quando uma ação mutativa é bloqueada no modo somente-leitura.
 */
export default function GlobalFreemiumUpsell() {
  const { isOpen, close } = useFreemiumUpsellStore();

  if (!isOpen) return null;

  return <FreemiumLockModal isOpen={isOpen} onClose={close} />;
}
